import {ModalFormFieldTypes} from 'components/formItems/FormGroup/FormGroup';

const fields: ModalFormFieldTypes[] = [
	{
		type: 'formGroup',
		name: 'admissionFiles',
		label: 'Ավելացնել փասթաթուղթ',
		disableDynamicActions: true,
		groupTitle: 'Փասթաթուղթ',
		minimaltem: 3,
		minReqItem: 3,
		colProps: {
			xs: 24
		},
		inputs: [
			{
				type: 'select',
				name: 'typeID',
				dictionaryApiPath: 'candidateFileTypes',
				isRequired: false,
				selectProps: {
					disabled: true
				},
				//@ts-ignore
				formItemProps: {
					noStyle: true
				},
				className: 'disabledSelect',
				colProps: {
					xs: 24,
					md: 24,
					lg: 18,
					xxl: 12
				},
				hiddenOptions: [1]
			},
			{
				type: 'file',
				name: 'path',
				depFieldKey: ['typeID'],
				uploadProps: {
					accept: 'image/jpeg, application/pdf'
				},
				depValue: [value => value !== 1 && value !== 4],
				//@ts-ignore
				isRequiredDep: [
					['typeID'],
					'genderTypeID',
					'militaryServiceID',
					'admissionLanguageExamPassTypeID',
					['path']
				],
				isRequired: ({
					typeID,
					genderTypeID,
					militaryServiceID,
					admissionLanguageExamPassTypeID,
					path
				}) => {
					if (typeof path === 'string' && path) return false;
					if (typeID < 5) return true;
					if (typeID === 5 && admissionLanguageExamPassTypeID === 2) return true;
					if (typeID === 6 && genderTypeID === 1 && militaryServiceID != 2) return true;
					return false;
				},
				colProps: {
					xs: 24,
					md: 24,
					lg: 18,
					xxl: 12
				}
			},
			{
				type: 'file',
				name: 'path',
				depFieldKey: ['typeID'],
				depValue: [value => value !== 1 && value === 4],
				//@ts-ignore
				isRequiredDep: [
					['typeID'],
					'genderTypeID',
					'militaryServiceID',
					'admissionLanguageExamPassTypeID',
					['path']
				],
				isRequired: ({
					typeID,
					genderTypeID,
					militaryServiceID,
					admissionLanguageExamPassTypeID,
					path
				}) => {
					if (typeof path === 'string' && path) return false;
					if (typeID < 5) return true;
					if (typeID === 5 && admissionLanguageExamPassTypeID === 2) return true;
					if (typeID === 6 && genderTypeID === 1 && militaryServiceID != 2) return true;
					return false;
				},
				colProps: {
					xs: 24,
					md: 24,
					lg: 18,
					xxl: 12
				},
				uploadProps: {
					accept: 'image/jpeg, application/pdf'
				}
			}
		]
	}
];

export default fields;
